import { useEffect } from "react";
import { viewPartners } from "../../states/actions/partnersAction";
import { useDispatch, useSelector } from "react-redux";
import BaseUrl from "../../service/API/base_url";

const Partners = () => {
  // dispatch
  const dispatch = useDispatch();

  // hooks
  const partners = useSelector((state) => state.partners);
  // console.log("partners: ", partners);
  // use effect
  useEffect(() => {
    dispatch(viewPartners());
  }, []);

  const apiPartners =
    partners?.partners?.map((p) => `${BaseUrl}${p.photo}`) || [];

  const marqueeLogos = [...apiPartners];

  return (
    <div className="bg-slate-100 dark:bg-slate-900 dark:text-white overflow-hidden">
      <div className="py-14">
        <div className="max-w-screen-xl mx-auto px-4 md:px-8">
          <div className="max-w-xl mx-auto text-center">
            <h3 className="text-3xl font-semibold sm:text-4xl">
              Partners Who’ve Trusted Us!
            </h3>
            <p className="mt-3">Stay Informed on Ethiopian Law</p>
          </div>

          {/* Marquee */}
          <div className="mt-12 relative overflow-hidden">
            <div className="flex gap-16 animate-marquee whitespace-nowrap">
              {marqueeLogos.map((logo, index) => (
                <img
                  key={index}
                  src={logo}
                  alt="Partner Logo"
                  className="w-32 object-contain"
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Tailwind custom animation */}
      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }

          .animate-marquee {
            display: flex;
            width: max-content;
            animation: marquee 20s linear infinite;
          }
        `}
      </style>
    </div>
  );
};

export default Partners;
